module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "dynamic-table"
  }, [_vm._c('table', {
    staticClass: "table table-striped"
  }, [_vm._c('thead', [_vm._c('tr', [_vm._l((_vm.cols), function(col) {
    return _vm._c('th', [_vm._c('span', {
      class: {
        'sort': (_vm.sort.by === col.prop)
      },
      on: {
        "click": function($event) {
          _vm.changeSort(col.prop)
        }
      }
    }, [_vm._v(_vm._s(col.name))]), _vm._v(" "), (_vm.sort.by === col.prop && _vm.sort.direction === 'desc') ? _vm._c('i', {
      staticClass: "fas fa-sort-amount-up"
    }) : _vm._e(), _vm._v(" "), (_vm.sort.by === col.prop && _vm.sort.direction === 'asc') ? _vm._c('i', {
      staticClass: "fas fa-sort-amount-down"
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.onClick) ? _vm._c('td') : _vm._e()], 2)]), _vm._v(" "), _vm._c('tbody', [_vm._l((_vm.rowData), function(row) {
    return (_vm.rowData.length > 0) ? _vm._c('tr', [_vm._l((row.data), function(col) {
      return _vm._c('td', [_vm._v("\n          " + _vm._s(col) + "\n        ")])
    }), _vm._v(" "), _vm._c('td', {
      staticClass: "text-right",
      on: {
        "click": function($event) {
          _vm.onClick(row.id)
        }
      }
    }, [_vm._m(0, true)])], 2) : _vm._e()
  }), _vm._v(" "), (_vm.rowData.length <= 0) ? _vm._c('tr', [_vm._c('td', {
    staticClass: "text-center xs-p-20",
    attrs: {
      "colspan": _vm.cols.length + (_vm.onClick ? 1 : 0)
    }
  }, [_vm._v("\n          No records to show\n        ")])]) : _vm._e()], 2), _vm._v(" "), (_vm.paging.show) ? _vm._c('tfoot', [_vm._c('tr', [_vm._c('td', {
    staticClass: "xs-pt-20 xs-pb-20",
    attrs: {
      "colspan": _vm.cols.length + (_vm.onClick ? 1 : 0)
    }
  }, [_vm._c('ul', {
    staticClass: "paging text-center"
  }, [_vm._c('li', [_vm._c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": _vm.paging.pageNum <= 1
    },
    on: {
      "click": _vm.prevPage
    }
  }, [_vm._c('i', {
    staticClass: "mdi mdi-chevron-left"
  })])]), _vm._v(" "), _vm._l((_vm.paging.numPages), function(p) {
    return _vm._c('li', [_vm._c('a', {
      staticClass: "btn btn-default",
      class: {
        'btn-primary': _vm.paging.pageNum === p
      },
      on: {
        "click": function($event) {
          _vm.changePage(p)
        }
      }
    }, [_vm._v(_vm._s(p))])])
  }), _vm._v(" "), _vm._c('li', [_vm._c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": _vm.paging.pageNum >= _vm.paging.numPages
    },
    on: {
      "click": _vm.nextPage
    }
  }, [_vm._c('i', {
    staticClass: "mdi mdi-chevron-right"
  })])])], 2)])])]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._c('i', {
    staticClass: "fas fa-edit"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2b8a99c8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/tables/DynamicTable.vue
// module id = 641
// module chunks = 1